import React from 'react';
import { useReminderModal } from './ReminderModalContext';
import { useEventInfo } from '@shared/utils/eventInfo';
import { ReminderModal } from '@shared/components/ReminderModal';
import { useGuestGuideTelemetry } from './GuestGuideTelemetry';

// Wrapper component that renders the ReminderModal
export const ReminderModalWrapper: React.FC = () => {
  const { isOpen, onClose } = useReminderModal();
  const { eventInfo } = useEventInfo();
  const telemetry = useGuestGuideTelemetry();
  if (!isOpen || !eventInfo?.eventId) {
    return null;
  }

  return (
    <ReminderModal
      isOpen={isOpen}
      onClose={onClose}
      eventId={eventInfo.eventId}
      telemetry={telemetry}
      customOffset={{ x: 16, y: 38 }}
      showNoThanksButton={false}
    />
  );
};
